<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo></BrokerpadLogo>

    <div class="p-8 bg-white mt-6 rounded shadow-lg border" @keyup.enter="submit">

      <!-- if valid is null, we are still checkinf if key is right in the URL -->
      <template v-if="valid == null">
      </template>

      <template v-else>

        <template v-if="valid"> 

          <div class="text-2xl font-light text-gray-700">
            Reset your {{ getAppName }} password
          </div>

          <div class="mt-8">
            <label class="text-base">New password</label>
          </div>

          <div class="mt-2">
            <InputBrokerpadPassword 
              v-bind:value="password"
              v-bind:updatePassword="updatePassword"></InputBrokerpadPassword>
          </div>

          <div v-if="errors.password !== null"
            class="text-red-500 mt-2 text-sm">{{ errors.password }}</div>

          <div class="mt-8">
            <label class="text-base">One more time please</label>
          </div>

          <div class="mt-2">
            <input 
              type="password"
              v-model="confirmPassword"
              class="input-standard" />
          </div>

          <div v-if="errors.confirmPassword !== null"
            class="text-red-500 mt-2 text-sm">{{ errors.confirmPassword }}</div>

          <div class="mt-8">
            <button
              v-on:click="submit"
              class="text-white py-4 w-full uppercase bg-blue-500 font-black hover:bg-blue-500">
              Submit
            </button>
          </div>

        </template>

        <template v-else>

          <div class="text-2xl font-light text-gray-700">
            Invalid password reset link.
          </div>

          <div class="mt-6 leading-normal text-base">
            Your link is either invalid or too old. 
            Please try to 
            <router-link :to="{ name : 'auth-forgot-password' }" tag="a" class="text-blue-500 hover:underline">reset your password again</router-link>.
          </div>
        </template>

      </template>
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>

  import axios                  from "axios";
  import { EventBus }           from '@/shared/event-bus';
  import InputBrokerpadPassword from '@/shared/components/form/InputBrokerpadPassword'
  import PublicFooter           from "@/shared/components/public/Footer";
  import BrokerpadLogo          from '@/shared/components/BrokerpadLogo';


    // function to reset errors
  function resetErrors() {
    return {
      password       : null,
      confirmPassword: null
    }
  }

  export default {

    components : {
      InputBrokerpadPassword,
      PublicFooter,
      BrokerpadLogo
    },

    data () {
      return {
        valid          : null,
        userId         : null,
        password       : null,
        confirmPassword: null,
        errors         : resetErrors()
      }
    },

    // when component is created, let's check to make sure that the key
    // is in fact a valid key
    created() {
      this.apiPost({
        key : this.$route.params.key,
      }, 'auth/validate-reset-password-key', (data) => {
        this.userId = data.userId
        this.valid  = true
      })
    },

    mounted() {
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },

    methods : {

      updatePassword(params) {
        if(params != null && params.value != null) {
          this.password = params.value
        }
      },

      submit() {
        let valid   = true;
        this.errors = resetErrors()

        if(this.password == null || this.password.length == 0) {
          this.errors.password = "Invalid password.";
          valid = false;
        }

        if(this.confirmPassword == null || this.confirmPassword.length == 0) {
          this.errors.confirmPassword = "Please type a valid confirm password.";
          valid = false;
        }

        if(this.password != null && this.password != this.confirmPassword) {
           this.errors.confirmPassword = "Password do not match.";
           valid = false;
        }

        if(valid) {
          this.apiPost({
            key     : this.$route.params.key,
            password: this.password,
            userId  : this.userId            
          }, 'auth/reset-password', () => {
            this.$router.push('/auth/reset-password-success');
          })
        }
      }
    },
  }
</script>